import React from 'react';
import PropTypes from 'prop-types';

export const ErrorMessage = ({ ...props }) => {
  ErrorMessage.propTypes = {
    errorMessage: PropTypes.string,
    errorImage: PropTypes.node.isRequired
  };

  return (
    <div className='empty-message-container'>
      <div className='message-holder'>
        <div>
          <img src={props.errorImage} alt='Error' className='error-icon' />
        </div>
        <div className='error-text'>{props.errorMessage}</div>
      </div>
    </div>
  );
};

export default ErrorMessage;
